import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';

// styles
import { header } from './styles/form';
import { MultiFactorAuthContainer } from './styles/multiFactorPage';

// types
import { Search } from 'js/auth/types/search';
import { OktaMfaFactor } from 'js/common/types/accountMultiFactorAuth';

// components
import { H2 } from '@leafygreen-ui/typography';
import HeaderLogo from './HeaderLogo';
import Layout from './Layout';
import VercelPage from 'js/common/components/Vercel/VercelPage';
import VercelLayout from 'js/common/components/Vercel/VercelLayout';
import VerifyFactorCard from 'js/common/components/MultiFactorAuth/VerifyFactorCard';

// utils
import { getUniqueFactors } from 'js/common/utils/multiFactorAuthUtils';

// api
import * as api from 'js/common/services/api';

interface MultiFactorPageProps {
  windowLocation?: Pick<Location, 'assign' | 'href' | 'search'>;
}

export default function VerifyAccountMultiFactorAuthPage({ windowLocation = window.location }: MultiFactorPageProps) {
  const parsedSearchLocation = queryString.parse(windowLocation.search) as Search;
  const { stateToken, isVercelIntegration } = parsedSearchLocation;
  const clientState = { ...parsedSearchLocation };

  const [userFactors, setUserFactors] = useState<Array<OktaMfaFactor>>([]);

  const onMfaVerificationSuccess = ({ loginRedirect }) => {
    windowLocation.assign(loginRedirect);
  };

  useEffect(() => {
    async function getFactors() {
      try {
        const {
          _embedded: { factors },
        } = await api.auth.getAuthMfaState({ stateToken });
        setUserFactors(factors);
      } catch (error) {
        console.log("An error has occurred while getting the user's MFA factors:", error);
        windowLocation.assign('/account/login');
      }
    }

    getFactors();
  }, [stateToken]);

  const renderUserFactors = () => {
    return (
      userFactors.length > 0 && (
        <VerifyFactorCard
          availableFactors={getUniqueFactors(userFactors)}
          clientState={clientState}
          onSuccess={onMfaVerificationSuccess}
          isVercelIntegration={isVercelIntegration}
        />
      )
    );
  };

  if (isVercelIntegration) {
    return (
      <VercelPage pageTitle="Verify Your Identity">
        <VercelLayout title="Verify Your Identity">{renderUserFactors()}</VercelLayout>
      </VercelPage>
    );
  }
  return (
    <>
      <Helmet title="Verify Your Identity" />
      <Layout contentPlacement="right">
        <MultiFactorAuthContainer>
          <HeaderLogo /> <H2 css={header}>Verify Your Identity</H2> {renderUserFactors()}
        </MultiFactorAuthContainer>
      </Layout>
    </>
  );
}
